import { NavLink, Outlet } from 'react-router-dom';
import { cn } from '@/lib/cn';

/*
 * Tab chrome for /billing — Claims (insurance + 837P) vs. Invoices
 * (private-pay bundles). Shared container sets the page title and owns the
 * top-level navigation; each sub-page (ClaimsTab / InvoicesTab) renders its
 * own action buttons + list below the tab strip.
 *
 * Both tabs live under a single max-width container so switching doesn't
 * cause a layout-width pop when the inner table changes.
 */

function Tab({ to, label }: { to: string; label: string }) {
    return (
        <NavLink
            to={to}
            className={({ isActive }) => cn(
                'px-4 py-1.5 text-sm rounded transition-colors',
                isActive
                    ? 'bg-surface text-text shadow-xs font-medium'
                    : 'text-text-muted hover:text-text',
            )}
        >
            {label}
        </NavLink>
    );
}

export function BillingLayout() {
    return (
        <div className="p-6 max-w-[1400px] mx-auto">
            <div className="mb-4">
                <h1 className="font-display text-2xl font-bold text-text">Billing</h1>
            </div>
            <nav
                aria-label="Billing sections"
                className="flex items-center gap-1 p-0.5 bg-surface-muted rounded-md w-fit mb-4"
            >
                <Tab to="/billing/claims"   label="Claims" />
                <Tab to="/billing/invoices" label="Invoices" />
            </nav>
            <Outlet />
        </div>
    );
}
